import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight, Clock } from "lucide-react";
import { OFFERINGS, waLink } from "../data/content";
import { Reveal, Eyebrow, EASE } from "./Reveal";

const Card = ({ item, index }) => (
  <motion.a
    href={waLink(`Namaste Shreya, I'd like to book the ${item.title}.`)}
    target="_blank"
    rel="noreferrer"
    data-testid={`offering-card-${item.id}`}
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, ease: EASE, delay: (index % 3) * 0.12 }}
    whileHover={{ y: -8 }}
    className="group relative block overflow-hidden rounded-[2rem] border border-[#CBA135]/25 shadow-[0_18px_50px_-24px_rgba(33,7,13,0.55)] hover:shadow-[0_28px_70px_-24px_rgba(33,7,13,0.7)] transition-shadow duration-500 aspect-[4/5]"
  >
    <img
      src={item.img}
      alt={item.title}
      className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.07]"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-[#140306] via-[#140306]/45 to-transparent" />

    {/* Consultation label + duration pill (top) */}
    <div className="absolute top-5 left-5 right-5 flex items-center justify-between">
      <span className="text-[10px] uppercase tracking-[0.28em] text-[#F4EBD9]/85 bg-[#140306]/40 backdrop-blur-sm px-3 py-1.5 rounded-full border border-white/15">
        Consultation
      </span>
      <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#21070D] bg-[#EBD08A] px-3 py-1.5 rounded-full shadow">
        <Clock size={13} /> {item.duration}
      </span>
    </div>

    {/* circular arrow */}
    <span className="absolute bottom-6 right-6 grid place-items-center h-12 w-12 rounded-full bg-[#F4EBD9]/15 backdrop-blur-md border border-[#EBD08A]/40 text-[#F4EBD9] transition-all duration-500 group-hover:bg-[#CBA135] group-hover:text-[#21070D] group-hover:scale-105">
      <ArrowUpRight size={20} />
    </span>

    {/* name + clear price (bottom) */}
    <div className="absolute bottom-0 left-0 right-0 p-7 pr-20">
      <h3 className="font-serif font-medium text-[#F9F1E2] text-2xl sm:text-3xl leading-tight [text-shadow:0_2px_16px_rgba(0,0,0,0.5)]">
        {item.title}
      </h3>
      <div className="mt-3 inline-flex items-baseline gap-2 rounded-xl bg-[#140306]/55 backdrop-blur-sm border border-[#EBD08A]/30 px-4 py-2">
        <span className="font-serif text-2xl sm:text-3xl text-[#EBD08A] leading-none">
          {item.price}
        </span>
        <span className="text-[#F4EBD9]/75 text-xs uppercase tracking-[0.16em]">
          / {item.duration}
        </span>
      </div>
    </div>
  </motion.a>
);

export const Offerings = () => (
  <section
    id="offerings"
    className="relative bg-[#F4EBD9] py-24 sm:py-36 px-6 sm:px-10 md:px-16"
    data-testid="offerings"
  >
    <div className="max-w-6xl mx-auto">
      <div className="text-center max-w-2xl mx-auto">
        <Reveal>
          <Eyebrow className="text-[#9C7526]">Offerings</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-5 font-serif font-medium text-[#21070D] text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            Sessions &amp; Sacred Offerings
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-5 text-[#3A1219] text-lg sm:text-xl body-serif">
            Choose the path that calls to you. Every session is private, gentle
            and tailored to where you are right now.
          </p>
        </Reveal>
      </div>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {OFFERINGS.map((item, i) => (
          <Card key={item.id} item={item} index={i} />
        ))}
      </div>
    </div>
  </section>
);

